<template>
    <div class="page-container">
      <h1>Error 404</h1>
      <p>Los Gogo Points se acercan.</p>
      <img src="../assets/crupier.jpg" alt="Logo" />
    </div>
  </template>
  
  <script>
  export default {
    name: "AppDeveloper",
  };
  </script>
  
  <style scoped>
  h1 {
    margin: 0.5em 0;
  }
  
  p {
    margin: 0.5em 0;
  }
  </style>
  